module.exports = __webpack_public_path__ + "static/media/disabled-ppt.f905197e.svg";